import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { useMutation } from '@sopranodesign/pulse-hooks';
import {
  Flex,
  Label,
  Button,
  useNotification
} from '@sopranodesign/pulse-components';
import { EmailSelect } from '@sopranodesign/pulse-integrations';

import Modal from '../../../Modal';
import { syncStepEmails } from '../../../../api/index';
import { useBuilder } from '../../../../hooks/index';

const AddEmailBlock = ({ handleClose, node }) => {
  const [email, setEmail] = useState(null);

  const { showSuccess } = useNotification();

  const { dispatch } = useBuilder();

  const { mutate, isPending } = useMutation({
    mutationFn: syncStepEmails,
    onSuccess: ({ data }) => {
      showSuccess('Successfully added a new email');
      dispatch({
        type: 'SYNC_STEP_EMAILS',
        stepId: node.id,
        newEmails: data.data
      });
      handleClose();
    }
  });

  const handleEmailChange = email => {
    setEmail(email ? email.value : null);
  };

  const valid = useMemo(() => {
    return Boolean(email);
  }, [email]);

  const handleSubmit = event => {
    event.preventDefault();

    if (!valid || isPending) {
      return;
    }

    mutate({
      stepId: node.id,
      emails: node.base.emails.map(email => email.id).concat(email)
    });
  };

  const getSelectedEmails = () => {
    return node.blocks?.filter(block => block.type === 'email'); // eslint-disable-line
  };

  return (
    <Modal header="Add email" handleClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <Flex col pad="true">
          <Flex mb col>
            <Label htmlFor="email">Email</Label>
            <EmailSelect
              id="email"
              value={email}
              onChange={handleEmailChange}
              currentlySelected={getSelectedEmails()}
            />
          </Flex>
          <Flex right>
            <Button
              variant="primary"
              type="submit"
              disabled={!valid || isPending}>
              Save
            </Button>
          </Flex>
        </Flex>
      </form>
    </Modal>
  );
};

AddEmailBlock.propTypes = {
  handleClose: PropTypes.func.isRequired,
  node: PropTypes.shape({
    id: PropTypes.number.isRequired,
    base: PropTypes.shape({
      emails: PropTypes.arrayOf(
        PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired
      ).isRequired
    }).isRequired,
    blocks: PropTypes.shape({
      type: PropTypes.string.isRequired
    })
  }).isRequired
};

export default AddEmailBlock;
